module.exports = __webpack_public_path__ + "static/media/login-bc.aa70cbaa.png";